import { render, staticRenderFns } from "./UserTaxProfile.vue?vue&type=template&id=e7444418&"
import script from "./UserTaxProfile.vue?vue&type=script&lang=js&"
export * from "./UserTaxProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports